import { Injectable, signal } from "@angular/core";
import { SearchFilter } from "../types/SearchFilter/SearchFilter";
import { SearchFilters } from "../types/SearchFilter/SearchFilters";

@Injectable({
  providedIn: "root",
})
export class FilterService {
  private defaultFilters: SearchFilters = {
    recordAssignedToUserID: {
      value: false,
      label: "Assigned To Me",
      type: "checkbox",
      src: "This_Form",
      key: "recordAssignedToUserID",
    },
  };

  private filters = signal<{ [key: string]: SearchFilters }>({});

  constructor() {
    this.resetFilters();
  }

  public addFilter(
    key: string,
    filterName: string,
    filter: SearchFilter,
  ): SearchFilters {
    this.filters.set({
      ...this.filters(),
      [key]: { ...this.filters()[key], [filterName]: filter },
    });
    return this.filters()[key];
  }

  public setFilters(key: string, filters: SearchFilters): SearchFilters {
    this.filters.set({ ...this.filters(), [key]: { ...filters } });
    return this.filters()[key];
  }

  public getFilters(): { [key: string]: SearchFilters } {
    return this.filters();
  }

  public resetFilters(): { [key: string]: SearchFilters } {
    const filters = { map: this.defaultFilters, search: this.defaultFilters };
    this.filters.set({ ...filters });
    return this.filters();
  }

  public removeFilter(key: string, filterName: string): SearchFilters {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { [filterName]: _, ...filters } = this.filters()[key];
    this.setFilters(key, filters);
    return this.filters()[key];
  }
}
